/* eslint-disable @typescript-eslint/no-explicit-any */
declare global {
  interface Window {
    google?: any;
  }
}

// MS289: read the key from VITE_GOOGLE_MAPS_API_KEY env var first;
// fall back to the prior hardcoded value so existing setups keep
// working. Rotating the key now means editing .env, no code change.
const MAPS_API_KEY =
  (import.meta.env.VITE_GOOGLE_MAPS_API_KEY as string | undefined) ||
  "AIzaSyAxXzfAG0ixqcboNPNLHw3T_gjUqHkJu0M";
const SCRIPT_ID = "google-maps-script";

export function loadGoogleMapsScript(): Promise<void> {
  return new Promise((resolve, reject) => {
    if (window.google?.maps?.places) {
      resolve();
      return;
    }
    if (document.getElementById(SCRIPT_ID)) {
      const check = setInterval(() => {
        if (window.google?.maps?.places) {
          clearInterval(check);
          resolve();
        }
      }, 100);
      return;
    }
    const script = document.createElement("script");
    script.id = SCRIPT_ID;
    script.src = `https://maps.googleapis.com/maps/api/js?key=${MAPS_API_KEY}&libraries=places`;
    script.async = true;
    script.defer = true;
    script.onload = () => resolve();
    script.onerror = () => reject(new Error("Failed to load Google Maps"));
    document.head.appendChild(script);
  });
}

export interface ParsedAddress {
  streetNumber: string;
  route: string;
  suburb: string;
  state: string;
  postcode: string;
  formatted: string;
}

export function parsePlace(place: any): ParsedAddress | null {
  if (!place?.address_components) return null;
  const parsed: ParsedAddress = {
    streetNumber: "",
    route: "",
    suburb: "",
    state: "",
    postcode: "",
    formatted: place.formatted_address || "",
  };
  for (const comp of place.address_components) {
    const types = comp.types as string[];
    if (types.includes("street_number")) parsed.streetNumber = comp.long_name;
    if (types.includes("route")) parsed.route = comp.long_name;
    if (types.includes("locality")) parsed.suburb = comp.long_name;
    if (types.includes("administrative_area_level_1")) parsed.state = comp.short_name;
    if (types.includes("postal_code")) parsed.postcode = comp.long_name;
  }
  return parsed;
}
